import { Button, Col, DatePicker, Form, Row, Select } from "antd";
import moment from "moment";
import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import styled from "styled-components";

const StyledFilterContainer = styled.div`
  &,
  & .filter {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    width: 100%;
    &__item {
      margin: 0.5rem;

      & .ant-form-item {
        margin: 0;
      }

      &--submit {
        align-self: flex-end;
      }
    }
  }
`;

export const PAYOUT_STATUSES = [
  { label: "Awaiting Approval", value: "AWAITING_APPROVAL" },
  { label: "Processing", value: "PROCESSING" },
  { label: "Success", value: "SUCCESS" },
  { label: "Failed", value: "FAILED" },
];

export const DEFAULT_PAYOUT_STATUS = "AWAITING_APPROVAL";

export const AppProcessEarningsFilter = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [form] = Form.useForm();

  useEffect(() => {
    const month = searchParams.get("month");
    const status = searchParams.get("status");
    form.setFieldsValue({
      month: month ? moment(month, "YYYY-MM") : moment(),
      status: status ?? DEFAULT_PAYOUT_STATUS,
    });
  }, [form, searchParams]);

  const onSearch = (values: { month?: moment.Moment; status?: string }) => {
    const params: Record<string, string> = {};
    if (values.month) params.month = values.month.format("YYYY-MM");
    if (values.status) params.status = values.status;
    setSearchParams(params);
  };

  const onReset = () => {
    const defaults = { month: moment(), status: DEFAULT_PAYOUT_STATUS };
    form.setFieldsValue(defaults);
    setSearchParams({
      month: moment().format("YYYY-MM"),
      status: DEFAULT_PAYOUT_STATUS,
    });
  };

  return (
    <StyledFilterContainer>
      <Form
        form={form}
        name="process-earnings-filter-form"
        onFinish={onSearch}
        layout="vertical"
        style={{ width: "100%" }}
      >
        <Row className="filter">
          <Col xs={20} sm={8} md={6} lg={5} className="filter__item">
            <Form.Item name="month" label="Month">
              <DatePicker
                picker="month"
                size="small"
                style={{ width: "100%" }}
                format="YYYY-MM"
              />
            </Form.Item>
          </Col>
          <Col xs={20} sm={8} md={6} lg={5} className="filter__item">
            <Form.Item name="status" label="Status">
              <Select size="small" style={{ width: "100%" }} options={PAYOUT_STATUSES} />
            </Form.Item>
          </Col>
          <Col xs={20} sm={4} md={2} lg={2} className="filter__item filter__item--submit">
            <Form.Item>
              <Button type="primary" htmlType="submit" size="small">
                Search
              </Button>
            </Form.Item>
          </Col>
          <Col xs={20} sm={4} md={2} lg={2} className="filter__item filter__item--submit">
            <Form.Item>
              <Button size="small" onClick={onReset}>
                Reset
              </Button>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </StyledFilterContainer>
  );
};
